import { ORIGIN_TSF, ORIGIN_URI_QUERY_PARAM_KEY } from 'constants/referer'
import { captureException } from 'helpers/raven'
import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { fetchNavigationRedirectMobile } from 'api/planet/navigation'
import * as Actions from 'store/actions/index.ts'
import {
  getMarketId,
  getMemberId
} from '../selectors'

const RedirectToNavigationEpic = (actions$, state$) => actions$.pipe(
  ofType(Actions.navigation.REDIRECT_TO_NAVIGATION),
  tap(() => {
    const marketId = getMarketId(state$.value)
    const memberId = getMemberId(state$.value)

    fetchNavigationRedirectMobile(marketId, memberId).subscribe(({ response }) => {
      if (response.result.length > 0) {
        window.location = response.result + `&${ORIGIN_URI_QUERY_PARAM_KEY}=${ORIGIN_TSF}`
      } else {
        captureException(new Error('Fetched an empty navigation redirection url'), {
          extra: { marketId, memberId },
          level: 'warning'
        })
      }
    }, error => {
      captureException(new Error('Unable to fetch navigation redirection url'), {
        extra: error,
        level: 'warning'
      })
    })
  }),
  ignoreElements()
)

export default RedirectToNavigationEpic
